import axios from "axios";
import dayjs from "dayjs";
import { store } from "../../App";

const CREATE = "/courses/create";

export const createCourse = async (data) => {
  try {
    await axios
      .post(`${CREATE}`, data)
      .then((res) => {
        // store.dispatch({ type: "CREATE_COURSE", data: res.data.data });
      })
      .catch((e) => {
        console.log(e);
      });
  } catch (e) {
    throw e;
  }
};

export const fetchRequestedCourse = async (data) => {
  try {
    const centerId=JSON.parse(localStorage.getItem('centerId')).centerId

    const res = await axios.get(`/courses?centerId=${centerId}&startDate=${dayjs().format('YYYY-MM-DD')}`);
    store.dispatch({ type: "FETCH_COURSES", data: res.data });
  } catch (e) {
    throw e;
  }
};
